import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SWAL } from 'src/app/app-const';
import { ApplicationUser } from 'src/app/core/backend/common/models';
import { AccountService } from 'src/app/core/backend/common/services';


@Component({
  selector: 'mg-change-pass-temp',
  templateUrl: './change-pass-temp.component.html',
  styleUrls: ['./change-pass-temp.component.scss']
})
export class ChangePassTempComponent {
  updateConfirmValidator(): void {
    /** wait for refresh value */
    Promise.resolve().then(() => this.registrationForm.controls.confirmPassword.updateValueAndValidity());
  }

  confirmationValidator: ValidatorFn = (control: AbstractControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.registrationForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };


  registrationForm = new FormGroup({
    password: new FormControl<string | undefined>(undefined, [Validators.required]),
    confirmPassword: new FormControl<string | undefined>(undefined, [Validators.required, this.confirmationValidator]),
  });

  user: ApplicationUser | undefined
  @Input()
  public set _setUser(userData: ApplicationUser | undefined) {
    this.registrationForm.reset();
    if (userData) {
      this.user = userData;      
    }
  }



  constructor(
    private accountServiceBE: AccountService,
    public activeModal: NgbActiveModal,
  ) {
    
  }



  loading = false;
  onSubmit() {

    // stop here if form is invalid
    if (this.registrationForm.invalid) {

      Object.values(this.registrationForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      SWAL('warning', 'يجب تعبئة جميع الحقول');
      return;
    } else {
      if (this.user?.id) {
        this.loading = true;
        this.accountServiceBE.setUserPasswordPost({
          body: {
            newPassword: this.registrationForm.value.password!,
            id: this.user?.id,
          }
        }).subscribe({
          next: (data) => {
            this.loading = false;
            SWAL('success', 'تم تغيير كلمة المرور بنجاح');
            this.activeModal.dismiss();
          },
          error: (err) => {
            this.loading = false;
            SWAL('error', err.error);
          }
        })
      }


    }
  }
}
